import React from "react";
import styled from "styled-components";
import { Modal } from "antd";
import ManageTodoListNoTemplate from "components/job/index/startJobStep/manageTodoList/noTemplate";
import ManageDatelineNoTemplate from "components/job/index/startJobStep/manageDateline/noTemplate";

const NewNoTemplateModal = (props) => {
  // Component Props
  const { todo, dateline, visible, onCancel, title } = props;

  // Component State
  const [doneCreate, setDoneCreate] = React.useState(false);

  // Component Function

  // Component Useeffect
  React.useEffect(() => {
    if (doneCreate) {
      onCancel();
    }
  }, [doneCreate]);

  return (
    <StyledModal
      title={title}
      style={{ top: 20 }}
      visible={visible}
      onCancel={onCancel}
      width={1000}
      footer={null}
      header={null}
    >
      <>{todo && <ManageTodoListNoTemplate setDoneCreate={setDoneCreate} />}</>
      <>
        {dateline && <ManageDatelineNoTemplate setDoneCreate={setDoneCreate} />}
      </>
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  .ant-modal-body {
    padding-top: ${(props) => props.theme.spacing[2]};
    padding-bottom: ${(props) => props.theme.spacing[2]};
    padding-left: ${(props) => props.theme.spacing[2]};
    padding-right: ${(props) => props.theme.spacing[2]};
  }
`;

export default NewNoTemplateModal;
